export default {
  userData: {},
  role: null,
  hasMentorAccount: false,
  hasMenteeAccount: false,
  hasAdminAccount: false,
  authenticationCheckDone: false 
}
